<script lang="ts" context="module">

    const activityClasses = {
        info: 'info'
    };

</script>
<script lang="ts">

    import { getContext } from "svelte";
    import { DISTANCE_TO_INTERACTIVE } from "../environment";
    import type { Activity, Coordinates } from "../global";
    import type Checkpoint from "../Model/Checkpoint";
    import { distanceCalculator, geolocation } from "../Services";
    
    export let checkpoint: Checkpoint;
    export let activity: Activity;
    export let disabled: boolean = false;

    const openActivity: (checkpoint: Checkpoint, activity: Activity) => void = getContext('openActivity');
    const activityType = activityClasses[activity.type];
    const userCoords = geolocation.coords;

    let isLock = true;

    $: updateLockState($userCoords);

    function updateLockState(userCoords: Coordinates) {

        if (!activity.restrict.includes('distance')) {
            isLock = false;
            return;
        }

        if (!userCoords) {
            isLock = true;
            return;
        }
        
        const distance = distanceCalculator.calcDistance(checkpoint.coordinates, userCoords);
        isLock = distance > (checkpoint.interactiveDistance || DISTANCE_TO_INTERACTIVE);
    }

    function onClick() {
        openActivity(checkpoint, activity);
    }

</script>

<style lang="scss">

    .activity-btn {
        padding: 0.5rem 1rem;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0.5rem;
        border-radius: 7px;
        border: none;
        background-color: var(--color-secondary);
        color: #fff;

        &.is-lock {
            background-color: #E4E4E4;
            color: #989898;
        }

        &:disabled {
            opacity: 0.5;
        }
    }

    .activity-icon {
        max-width: 1rem;
        max-height: 1rem;
    }

</style>

<button type="button" {disabled} class="activity-btn activity-{activityType}-btn" class:is-lock={isLock} on:click={onClick}>
    {#if isLock}
    <img class="activity-icon" src="/images/lock.svg" alt=""> Acceso restringido
    {:else}
    <img class="activity-icon" src="/images/icon-{activityType}.svg" alt=""> Más información
    {/if}
</button>
